/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { TimeZoneOffsetDto as DigiworkMaitreDDtoAdvertiserTimeZoneOffsetDto } from '../../models/Digiwork/MaitreD/DTO/Advertiser/time-zone-offset-dto';

export interface GetVenueTimeZoneOffset$Params {
  venueId?: string;
}

export function getVenueTimeZoneOffset(http: HttpClient, rootUrl: string, params?: GetVenueTimeZoneOffset$Params, context?: HttpContext): Observable<StrictHttpResponse<DigiworkMaitreDDtoAdvertiserTimeZoneOffsetDto>> {
  const rb = new RequestBuilder(rootUrl, getVenueTimeZoneOffset.PATH, 'get');
  if (params) {
    rb.query('venueId', params.venueId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DigiworkMaitreDDtoAdvertiserTimeZoneOffsetDto>;
    })
  );
}

getVenueTimeZoneOffset.PATH = '/api/gmn/Venue/get-venue-time-zone-offset';
